import { EditorFile, EditorFileId } from "../gen/ClientState";
import { EditorPanel } from "./EditorPanel";
import { IEditorPanel } from "./IEditorPanel";

export function createEditorPanel(
  root: HTMLElement,
  initialEditors: EditorFile[],
  activeEditor: EditorFileId | null,
  events: IEditorPanel.Events
): IEditorPanel {
  return new EditorPanel(root, initialEditors, activeEditor, events);
}
